import { Button, Col, Row } from "antd";
import { ReactNode, useEffect, useState } from "react";
import {
  ButtonC,
  CardC,
  FormC,
  FormItemC,
  IconC,
  InputC,
  ModalC,
  SwitchC,
} from "..";
import { InputComponentProps } from "../InputC/Input.Component";
import filterSvg from "src/shared/assets/svg/icon/filter.svg";
import colSettingSvg from "src/shared/assets/svg/icon/colSetting.svg";
import exportSvg from "src/shared/assets/svg/icon/export.svg";
import searchSvg from "src/shared/assets/svg/icon/search.svg";
import dragSvg from "src/shared/assets/svg/icon/drag.svg";

import useDirection from "src/shared/hooks/useDirection";
import { ColumnsType } from "antd/lib/table";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { useTranslation } from "react-i18next";
import useFilter from "src/shared/hooks/useFilter";
import { useHistory } from "react-router-dom";
import { queryParse } from "src/shared/function/queryParse";
import useRequest from "src/shared/hooks/useRequest";
import useDate from "src/shared/hooks/useDate";

interface TableFilterCProps {
  children?: ReactNode;
  searchProps?: InputComponentProps;
  newColumns?: ColumnsType<any>;
  setNewColumns: React.Dispatch<
    React.SetStateAction<ColumnsType<any> | undefined>
  >;
  columnName?: string;
  exportApi?: any;
}
const TableFilterC = (TableFilterCProps: TableFilterCProps) => {
  const {
    children,
    newColumns,
    searchProps,
    setNewColumns,
    columnName,
    exportApi,
  } = TableFilterCProps;
  const { styler } = useDirection();
  const { t } = useTranslation();
  const { onFilter, onReset } = useFilter();
  const {
    push,
    location: { search },
  } = useHistory();
  const { onGet, loading, onDownload } = useRequest();
  const { toLocalDateAndTimeString } = useDate();
  const [modalVisible, setModalVisible] = useState({ colSetting: false });
  const [switchChange, setSwitchChange] = useState<any>(newColumns);
  useEffect(() => {
    setSwitchChange(newColumns);
  }, [JSON.stringify(newColumns)]);
  const query = queryParse(search);
  const showColHandler = (title: any, show: boolean) => {
    let oldSetting = switchChange;
    let newSetting = oldSetting?.map((item: any) =>
      item.title == title ? { ...item, show } : item
    );
    // localStorage.setItem(
    //   columnName,
    //   JSON.stringify(
    //     newSetting
    //       ?.filter((item: any) => item.show)
    //       .map((item: any) => item.dataIndex)
    //   )
    // );
    setSwitchChange(newSetting);
    // setNewColumns(newSetting);
  };

  const resetSetting = () => {
    setNewColumns(newColumns?.map((item) => ({ ...item, show: true })));
    columnName && localStorage.removeItem(columnName);
    // setModalVisible({ colSetting: false });
  };

  const saveSetting = () => {
    const keys = switchChange
      ?.filter((item: any) => item.show)
      .map((item: any) => item.dataIndex);

    columnName && localStorage.setItem(columnName, JSON.stringify(keys));

    setNewColumns(switchChange);
    onFilter({ fields: keys });
    setModalVisible({ colSetting: false });
  };
  return (
    <div>
      <CardC style={{ borderTopWidth: "0px" }}>
        <Row>
          <Col span={24}>
            <Row align="middle" justify="space-between" gutter={[10, 10]}>
              <Col xs={24} md={12} lg={6}>
                <FormC>
                  <InputC
                    col={{ xs: 24 }}
                    placeholder={t("search")}
                    formItem={{
                      label: " ",
                      initialValue: query?.keyword,
                      name: "keyword",
                    }}
                    suffix={<img src={searchSvg} />}
                    onPressEnter={(e: any) => {
                      e.preventDefault();
                      onFilter({ keyword: e.target.value });
                    }}
                    {...searchProps}
                  />
                </FormC>
              </Col>
              <Col xs={24} md={12} lg={10}>
                <Row justify="space-between" gutter={[10, 10]}>
                  <Col xs={24} lg={8}>
                    <ButtonC
                      type="default"
                      icon={
                        <IconC
                          type="ReloadOutlined"
                          // style={{ ...styler({ marginLeft: "8px" }) }}
                        />
                      }
                      onClick={onReset}
                    >
                      {t("reset all filters")}
                    </ButtonC>
                  </Col>
                  <Col xs={24} lg={8}>
                    <ButtonC
                      type="default"
                      icon={
                        <IconC
                          type="InsertRowLeftOutlined"
                          // style={{ ...styler({ marginLeft: "8px" }) }}
                        />
                      }
                      onClick={() =>
                        setModalVisible({ ...modalVisible, colSetting: true })
                      }
                    >
                      {t("adjust columns")}
                    </ButtonC>
                  </Col>
                  <Col xs={24} lg={8}>
                    <ButtonC
                      type="default"
                      icon={<IconC type="DownloadOutlined" />}
                      onClick={() =>
                        onDownload(exportApi(), {
                          fileName: `${columnName}-${toLocalDateAndTimeString(
                            Date.now()
                          )}.csv`,
                        })
                      }
                      loading={loading}
                    >
                      {t("export")}
                    </ButtonC>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
          <ModalC
            onCancel={() =>
              setModalVisible({ ...modalVisible, colSetting: false })
            }
            visible={modalVisible.colSetting}
            footer={null}
          >
            <FormC>
              <Row gutter={[10, 10]}>
                {switchChange?.map((item: any) => (
                  <Col span={24} key={item.title}>
                    {/* <FormItemC > */}
                    <SwitchC
                      disabled={
                        (switchChange?.filter(
                          (i: any) => i.show == true || i.show != false
                        ).length == 1 &&
                          item.show == true) ||
                        item.disabledSetting
                      }
                      checked={item.show}
                      onChange={(e) => showColHandler(item.title, e)}
                    >
                      {item.title}
                    </SwitchC>
                    {/* </FormItemC> */}
                  </Col>
                ))}
                <Col span={24}>
                  <Button.Group style={{ width: "100%" }}>
                    <ButtonC onClick={resetSetting} block type="dashed">
                      بازنشانی تنظیمات
                    </ButtonC>
                    <ButtonC block onClick={saveSetting}>
                      ذخیره و اعمال تغییرات
                    </ButtonC>
                  </Button.Group>
                </Col>
              </Row>
            </FormC>
          </ModalC>
          <Col span={24}> {children}</Col>
        </Row>
      </CardC>
    </div>
  );
};

export default TableFilterC;
